<template>
	<button type="button" class="input-like" @click.stop="toggle">
		<i v-if="checked" class="fa-solid fa-toggle-on text-green-600"/>
		<i v-else class="fa-solid fa-toggle-off text-red-600"/>
		<span class="grow">{{ trans(label) }}</span>
	</button>
</template>
<script setup lang="ts">
import {ref, type Ref, defineProps, defineEmits} from 'vue'
import {trans} from 'laravel-vue-i18n'

const props = defineProps<{
	value:string,
	label:string,
	checked:boolean,
}>()

const emit = defineEmits([
	'checked',
	'unchecked',
])

const checked:Ref<boolean> = ref(props.checked)

function toggle():void{
	if(checked.value){
		checked.value = false
		emit('unchecked')
	} else {
		checked.value = true
		emit('checked')
	}
}
</script>